import localization from './localization.js';

const maxSize = 10 * 1024 * 1024;


class contactDetailValidator {
    constructor() {
        this.errorMessages = {
            "phone": {
                emailAndPhoneMissing: localization.emailOrPhoneIsRequired,
                invalidPhoneNumber: localization.invalidPhonenumber,
                phoneMissing: localization.thisDetailRequired
            },
            "email": {
                emailAndPhoneMissing: localization.emailOrPhoneIsRequired,
                invalidEmail: localization.invalidEmail
            },
            "consent":
            {
                valueMissing: localization.thisDetailRequired
            },
            "attachments":
            {
                fileTooLarge: "Liitteen maksimikoko 10 MB."
            }
        };


        this.fieldValidators = {
            "phone": {
                emailAndPhoneMissing: (newValue, model) => newValue || model.email,
                invalidPhoneNumber: (newValue, model) => !newValue || newValue.length > 6
            },
            "email": {
                emailAndPhoneMissing: (newValue, model) => newValue || model.phone,
                invalidEmail: (newValue, model) => !newValue || newValue.includes("@")
            },
            "consent": {
                valueMissing: function (newValue, model) { return newValue === true; }
            },
            "attachments":
            {
                fileTooLarge: (newValue, model) => newValue ? newValue.every(f => f.size <= maxSize) : true
            }
        };
    }
    validate(values) {
        const errors = {}
        for (let propertyName in this.fieldValidators) {
            for (let validator in this.fieldValidators[propertyName]) {
                let validatorFunction = this.fieldValidators[propertyName][validator];
                let propertyValue = values[propertyName];
                if (!validatorFunction(propertyValue, values)) {
                    errors[propertyName] = this.errorMessages[propertyName][validator];
                    break;
                }
            }
        }
        return errors;
    }
    validators(field) {

        return this.fieldValidators[field];
    }
    messages(field) {
        return this.errorMessages[field];
    }
}
export default contactDetailValidator;






